import { connect } from 'react-redux';
import { makeGiveLlamaXHRCall } from '../simpleXHR/actionCreators';
import { getGiveLlamaXHRCallResult, getIsLoadingForGiveLlamaXHR } from '../simpleXHR/selectors';
const mapStateToProps = (state)=>{
    var _getGiveLlamaXHRCallResult, _getGiveLlamaXHRCallResult_errorDetails, _getGiveLlamaXHRCallResult1;
    return {
        isLoading: getIsLoadingForGiveLlamaXHR(state),
        isSuccess: !((_getGiveLlamaXHRCallResult = getGiveLlamaXHRCallResult(state)) === null || _getGiveLlamaXHRCallResult === void 0 ? void 0 : _getGiveLlamaXHRCallResult.errorDescription),
        errorReason: (_getGiveLlamaXHRCallResult1 = getGiveLlamaXHRCallResult(state)) === null || _getGiveLlamaXHRCallResult1 === void 0 ? void 0 : (_getGiveLlamaXHRCallResult_errorDetails = _getGiveLlamaXHRCallResult1.errorDetails) === null || _getGiveLlamaXHRCallResult_errorDetails === void 0 ? void 0 : _getGiveLlamaXHRCallResult_errorDetails.reason
    };
};
const mapDispatchToProps = (dispatch, { username, onBadgeSent })=>({
        init: ()=>{
            dispatch(makeGiveLlamaXHRCall({
                username,
                onBadgeSent
            }));
        }
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=GiveLlamaPopup.container.js.map